"use client";
import CustomCheckboxField from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomCheckboxField";
import CustomCountryCodeField from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomCountryCodeField";
import CustomDateField from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomDateField";
import CustomDropdownField from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomDropdownField";
import CustomFormText from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomFormText";
import CustomRadioField from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomRadioField";
import CustomResidenceStateField from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomResidenceStateField";
import CustomSingleCheckboxField from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomSingleCheckboxField";
import CustomTextField from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomTextField";
import { type FormFieldProps } from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/types";
import {
  FormBuilderFieldCode,
  FormBuilderFieldInputType,
} from "@/constants/form-builder";

export default function FormFieldMapper(props: FormFieldProps) {
  const { field } = props;

  if (field.code === FormBuilderFieldCode.StateOfResidence) {
    return <CustomResidenceStateField field={field} />;
  }

  switch (field.inputType) {
    case FormBuilderFieldInputType.Text:
      return <CustomTextField field={field} />;
    case FormBuilderFieldInputType.None:
      return <CustomFormText field={field} />;
    case FormBuilderFieldInputType.Dropdown:
      return <CustomDropdownField field={field} />;
    case FormBuilderFieldInputType.Radio:
      return <CustomRadioField field={field} />;
    case FormBuilderFieldInputType.Checkbox:
      return <CustomCheckboxField field={field} />;
    case FormBuilderFieldInputType.SingleCheckbox:
      return <CustomSingleCheckboxField field={field} />;
    case FormBuilderFieldInputType.Date:
      return <CustomDateField field={field} />;
    case FormBuilderFieldInputType.CountryCodeDropdown:
      return <CustomCountryCodeField field={field} />;
    default:
      return null;
  }
}
